import { Form } from 'data/Form'
import { PassTierFormField } from 'data/PassTier'
import React from 'react'
import Select from 'react-dropdown-select'
import SimpleInput from 'components/common/SimpleInput/SimpleInput'
import { isNil } from 'lodash'
import { useStyles } from './styles'
import SimpleCheckbox from 'components/common/SimpleCheckbox/SimpleCheckbox'

interface PassTierFieldProps {
    field: PassTierFormField
    form: Form
}

export const PassTierField: React.FC<PassTierFieldProps> = ({ field, form }) => {
    const classes = useStyles()

    const { touched, errors, eventHandlers, values, valueHandlers } = form

    if (isNil(values[field._id])) {
        return <span />
    }

    switch (field.type) {
        case 'checkbox':
            return (
                <SimpleCheckbox
                    label={field.label}
                    onValueChange={valueHandlers[field._id]}
                    required={field.required}
                    error={touched[field._id] && errors[field._id]}
                    value={values[field._id]}
                    tooltipText=""
                />
            )
        case 'input':
            return (
                <SimpleInput
                    error={touched[field._id] && errors[field._id]}
                    onChange={eventHandlers[field._id]}
                    value={values[field._id]}
                    label={`${field.label}${field.required ? ' *' : ''}`}
                    type="text"
                    placeholder={field.placeholder || ''}
                    maxLength={100}
                />
            )
        case 'select':
            return (
                <div>
                    <Select
                        values={
                            values[field._id].length
                                ? [
                                      {
                                          label: values[field._id],
                                          value: values[field._id],
                                      },
                                  ]
                                : []
                        }
                        className={classes.select}
                        options={field.options ? field.options.map(option => ({ label: option, value: option })) : []}
                        onChange={values => {
                            valueHandlers[field._id](values[0].value)
                        }}
                        placeholder={`${field.label}${field.required ? ' *' : ''}`}
                        required={!!field.required}
                        name={field._id}
                        searchable={false}
                        style={{ paddingLeft: 10, paddingRight: 10 }}
                    />
                    {errors[field._id] && <div className={classes.error}>{errors[field._id]}</div>}
                </div>
            )
        case 'display-only':
        default:
            return <></>
    }
}

export default React.memo(PassTierField)
